import { render, staticRenderFns } from "./DonHang.vue?vue&type=template&id=3f2d05bc&scoped=true&"
import script from "./DonHang.vue?vue&type=script&lang=js&"
export * from "./DonHang.vue?vue&type=script&lang=js&"
import style0 from "./DonHang.vue?vue&type=style&index=0&id=3f2d05bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d05bc",
  null
  
)

export default component.exports